<template><!-- svgo-optimised -->
<svg
  class="icon icon__arrow icon__arrow--horizontal"
  viewBox="0 0 48 25"
  xmlns="http://www.w3.org/2000/svg"
  fill="currentColor"
  stroke="black"
>
  <rect
    y="23.7783"
    width="48"
    height="1"
    fill="white"
  />
  <rect
    x="0.5"
    y="1.27832"
    width="47"
    height="24"
    stroke="currentColor"
  />
  <path
    d="M28.2857 6.77832L27.2786 7.7477L31.2643 11.5908H14V12.9658H31.2643L27.2786 16.8089L28.2857 17.7783L34 12.2783L28.2857 6.77832Z"
    fill="black"
    stroke="transparent"
  />
</svg></template>